import React from "react";
import { Pie } from "@ant-design/plots";
import Style from "./index.module.scss";
import { PieConfig } from "@ant-design/plots/es/components/pie";
import { LabelAndValue } from "../../../../service/evaluate";
interface Props {
    data: LabelAndValue[];
}
const Index = ({ data }: Props) => {
    const config: PieConfig = {
        data,
        angleField: "value",
        colorField: "label",
        radius: 1,
        innerRadius: 0.75,
        legend: {
            flipPage: false,
            layout: "vertical",
            position: "right",
            maxWidth: 350,
            itemValue: {
                formatter(datum, item, index) {
                    return data[index].value + "人";
                }
            }
        },
        tooltip: {
            formatter: datum => {
                return { name: datum.label, value: datum.value + "人" };
            }
        },
        label: {
            type: "outer",
            formatter(e) {
                return e.label;
            }
        },
        padding: [30, 30, 60, 0],
        statistic: {
            title: {
                style: {
                    fontSize: "16px",
                    color: "#999"
                },
                content: "总人数"
            },
            content: {
                style: {
                    fontSize: "22px",
                    marginTop: "10px"
                },
                formatter(data, list) {
                    return (
                        list?.reduce((r, d) => r + d.value, 0).toString() || ""
                    );
                }
            }
        }
    };
    return (
        <div className={Style.root}>
            <Pie {...config} />
        </div>
    );
};

export default Index;
